import React from "react";
import Link from "../../Link";

import Label from "../Label";
//
import Social from "./component/Social";
import PlayerIcon from "./component/PlayerIcon";
import PhotoCount from "./component/PhotoCount";
import Partner from "./component/Partner";
import ReadLaterIcon from "../../ReadLater";

const Pile = props => {
  var s = props.settings,
    thumbnailHeight = props.thumbnailHeight > 0 ? props.thumbnailHeight : 275,
    bi = s["background-image"] ? s["background-image"] : "",
    biLink =
      window.MEDIA_DOMAIN +
      "/" +
      bi.replace(".", ",3025," + thumbnailHeight + ",0,0."),
    miLink = window.MEDIA_DOMAIN + "/" + bi.replace(".", ",3025,220,0,0."),
    style = {
      backgroundImage: "url(" + biLink + ")"
    },
    classes = "nt-lazy-load " + props.classes,
    title = [];

  if (s.title_mega && s.title_mega.length > 0) {
    title.push(
      <h2
        key={s.title_mega}
        className="hp__box__title hp__box__title--mega no-margin-padding"
      >
        {s.title_mega}
      </h2>
    );
  }

  if (s.title_normal && s.title_normal.length > 0) {
    title.push(
      <h2 key={s.title_normal} className="hp__box__title no-margin-padding">
        {s.title_normal}
      </h2>
    );
  }

  return (
    <Link
      to={s.link}
      className={classes}
      style={style}
      {...props.events}
      data-original={biLink}
      data-original-mobile={miLink}
    >
      <ReadLaterIcon
        image={biLink}
        // Nie wiem czy takie wyciąganie wartości jest ok, ale działa
        title={title[0].key}
        link={s.link}
      />
      {props.gradient ? (
        <div className="hp__box__gradient gradient col-xs-12" />
      ) : null}

      <Partner partner={s.partner} />
      <PlayerIcon show={s.player} type={props.block_type} />
      <PhotoCount count={s.photo_count} type={props.block_type} />

      <div className="hp__box__content caption col-xs-12">
        {s.label && s.label.length > 0 ? (
          <Label pile className="hp__box__label">
            {" "}
            {s.label}{" "}
          </Label>
        ) : null}

        {title}
        <Social link={s.link} />
      </div>
    </Link>
  );
};

export default Pile;
